<script>
import filterTypes from './enums/filterTypes'

  export default {
    props: {
      tableHeaders: {
        type: Array,
      },
      rows: { 
        type: Array,
        default: [],
      },
      rowKey: {
        type: String,
        default: 'id',
      },
      defaultOrderFilter: {
        type: Object,
      },
      isVisibleOrderByColumn: {
        type: Boolean,
        default: true,
      },
      disableSelection: {
        type: Boolean,
        default: false,
      },
      disableActions: {
        type: Boolean,
        default: false,
      },
      isLoadingData: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        selectedRows: [],
        orderFilter: {
          key: this.defaultOrderFilter?.key ?? null,
          type: this.defaultOrderFilter?.type ?? null,
        },
      }
    },
    methods: {
      setSelectedRows(selectedRows) {
        this.selectedRows = selectedRows
      },
      selectAllRows(event) {
        if (event.target.checked) {
          this.selectedRows = this.allRowKeys
        } else {
          this.selectedRows = []
        }

        this.$emit('changeSelectedRows', JSON.parse(JSON.stringify(this.selectedRows)))
      },
      handleCheckboxClick(event) {
        const isAllRowsSelected = this.$refs.isAllRowsSelected.checked
        if (event.target.checked && !isAllRowsSelected && this.allRowKeys.length == (this.selectedRows.length + 1)) {
          this.selectedRows = this.allRowKeys
        } else if (!event.target.checked && isAllRowsSelected) {
          this.selectedRows = this.selectedRows.filter(rowKey => rowKey != event.target.value)
        } else if (event.target.checked) {
          this.selectedRows.push(event.target.value)
        } else {
          this.selectedRows = this.selectedRows.filter(rowKey => rowKey != event.target.value)
        }
        this.$emit('changeSelectedRows', JSON.parse(JSON.stringify(this.selectedRows)))
      }
    },
    computed: {
      allRowKeys() {
        return this.rows.map(row => row[this.rowKey])
      },
      filterTypes() {
        return filterTypes
      },
      columnPercentageWidth() {
          return 100 / (this.tableHeaders.length + 1)
      },
    },
    watch: {
      orderFilter: {
        handler(oldValue, newValue) {
          this.$emit('changeOrderFilter', JSON.parse(JSON.stringify(this.orderFilter)))
        },
        deep: true,
      },
    },
    created() {
      this.orderFilter = this.defaultOrderFilter ?? {
        key: this.tableHeaders[0].key,
        type: filterTypes.asc,
      }
    },
  }
</script>

<template>
  <div style="overflow-x: auto;">
    <table class="table">
      <thead class="text-ascpercase">
        <tr>
            <th v-if="!disableSelection">
              <input
                ref="isAllRowsSelected" 
                type="checkbox"
                :checked="rows.length && selectedRows.length === allRowKeys.length"
                :disabled="!rows.length"
                @click="selectAllRows"
              />
            </th>
            <th scope="col" v-for="header in tableHeaders" :key="header.key" :style="{width: columnPercentageWidth + '%'}">
              <div style="display: flex; gap: 5px;">
                {{header.label}}
                <div style="display: flex; flex-direction: column;" v-if="isVisibleOrderByColumn">
                  <span style="cursor: pointer; line-height: 1em;" @click="orderFilter = { key: header.key, type: filterTypes.asc }">{{ orderFilter.type === filterTypes.asc && orderFilter.key === header.key ? '▲' : '△' }}</span>
                  <span style="cursor: pointer; line-height: 1em;" @click="orderFilter = { key: header.key, type: filterTypes.desc }">{{ orderFilter.type === filterTypes.desc && orderFilter.key === header.key ? '▼' : '▽'}}</span>
                </div>
              </div>
            </th>
            <th v-if="!disableActions" scope="col" class="text-center">Opciones</th>
        </tr>
      </thead>

      <tbody>
        <tr v-if="isLoadingData">
          <td :colspan="tableHeaders.length + 1" class="text-center">Cargando...</td>
        </tr>
        <template v-else>
          <tr v-for="row in rows">
              <td v-if="!disableSelection">
                <input
                  type="checkbox"
                  :checked="selectedRows.includes(row[rowKey])"
                  :value="row[rowKey]"
                  @click="handleCheckboxClick"
                />
              </td>
              <td v-for="header in tableHeaders" :key="header.key">
                  <slot :name="`column-${header.key}`" v-bind:row="row" />
              </td>
              <td class="text-center" v-if="!disableActions">
                  <slot name="actions" v-bind:row="row" />
              </td>
          </tr>
      </template>

      </tbody>
    </table>
  </div>
</template>